
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_11n0s_hifrk_9",
  "empty": "awsui_empty_11n0s_hifrk_13"
};
  